/* eslint-disable react/style-prop-object */
import { TextTooltip } from "components/ui/Tooltip";
import Twemoji from "components/ui/Twemoji";
import classNames from "components/ui/classNames";
import { FormattedDisplayName, useIntl } from "react-intl";

interface DisplayCurrencyProps {
  currency: string;
  emoji: string;
}
export const DisplayCurrency = ({ currency, emoji }: DisplayCurrencyProps) => {
  const intl = useIntl();
  return (
    <TextTooltip
      asChild={true}
      side="top"
      align="start"
      delayDuration={1000}
      contentClassName="font-bold"
      content={intl.formatMessage({
        defaultMessage: "Moeda utilizada para exibir os dados financeiros",
        id: "qSHDoq",
      })}
    >
      <span
        className={classNames(
          "inline-flex items-center gap-x-1 truncate rounded-md bg-viridian-100/70 px-1.5 py-1 text-xs font-bold leading-4 text-viridian-600",
          "dark:bg-viridian-400/30 dark:text-viridian-300",
        )}
      >
        <Twemoji emoji={emoji} height={12} />
        <FormattedDisplayName type="currency" value={currency} /> ({currency})
      </span>
    </TextTooltip>
  );
};
